
import {SupportMimesTypes, supportTypes} from '@/image-processor';
import {computed, defineComponent, inject, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useStore} from '@/store';
import {key as keyToast} from '@/toast';

export default defineComponent({
  setup() {
    const {t, availableLocales, locale} = useI18n({useScope: 'global'});
    const store = useStore();
    const toastForbiddenClipboard = ref<HTMLElement>();
    const showToast = inject(keyToast);
    const fileList = computed(() => store.state.fileList);
    const getImageFromFilePicker = async () => {
      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = true;
      input.accept = Array.from(supportTypes, type => type[0]).join(',');
      input.onchange = () => {
        if (!input.files) return;
        for (const file of input.files) {
          if (supportTypes.has(file.type as SupportMimesTypes)) {
            store.commit('setFile', file);
          }
        }
      };
      input.click();
    };

    const getImageFromClipboard = async () => {
      const permission = await navigator.permissions.query({
        name: 'clipboard-read' as PermissionName, //trouble with TS >= 4.4.2
      });
      if (permission.state === 'denied') {
        if (showToast) {
          showToast({
            title: t('filelist.notice.forbidden-clipboard.title'),
            text: t('filelist.notice.forbidden-clipboard.text'),
            type: 'warning',
            duration: 5000,
          });
        }

        return;
      }
      const data = await navigator.clipboard.read();
      const allowImageClipboardExtension = 'png';
      const allowImageType = SupportMimesTypes[allowImageClipboardExtension];

      for (let i = 0; i < data.length; i++) {
        if (!data[i].types.includes(allowImageType)) {
          if (showToast) {
            showToast({
              title: t('filelist.notice.incompatible-clipboard-data.title'),
              text: t('filelist.notice.incompatible-clipboard-data.text'),
              type: 'warning',
              duration: 5000,
            });
          }
          continue;
        }
        const blob = await data[i].getType(allowImageType);
        const file = new File(
          [blob],
          t('filelist.clipboard.default-filename') +
            '_' +
            Date.now() +
            '.' +
            allowImageClipboardExtension,
          {
            type: blob.type,
          }
        );
        store.commit('setFile', file);
      }
    };

    return {
      t,
      availableLocales,
      store,
      locale,
      fileList,
      getImageFromFilePicker,
      getImageFromClipboard,
      toastForbiddenClipboard,
    };
  },
});
